import React from "react";

import SkeletonHeadingComponent from "@/components/global/HeadingTextAndReadMoreComponent/SkeletonHeadingComponent";

import SkeletonFlightPromotionCardsComponent from "../../flights/components/FlightPromotionCardsComponents/SkeletonFlightPromotionCardsComponent";

interface CrossSellSkeletonComponentProps {}

const CrossSellSkeletonComponent: React.FC<
  CrossSellSkeletonComponentProps
> = () => {
  return (
    <div className="max-h-72 p-4 md:mx-auto md:max-h-full md:max-w-7xl md:pb-4 md:pt-10">
      <SkeletonHeadingComponent />
      <SkeletonFlightPromotionCardsComponent
        isShowTab
        isSmallCard
        classNames={{
          container: "w-[10.25rem] md:w-72",
          image: "h-[7.625rem] md:h-[216px]",
          base: "gap-2 overflow-hidden md:gap-4",
          detail: "p-2 md:p-4",
          subBase: "gap-2  md:gap-4",
        }}
      />
    </div>
  );
};

export default CrossSellSkeletonComponent;
